<template>
  <div class="product">
    <div class="index-image">
      <div class="inner-text">
        <p class="title">Customized content</p>
        <p class="content">Provide solutions for customers to build a content module for products. Adopt short videos, medium-sized videos and information content, build content consumption scenarios and help customers improve the spent time of users and the value of internet traffic.</p>
      </div>
    </div>
    <div class="index-next-content">
      <div class="inner-content">
        <div class="main-title">Help enterprise collect receivable</div>
        <div class="box-card">
          <el-carousel :interval="4000" type="card" height="510px">
            <el-carousel-item v-for="item in listArr" :key="item">
              <div class="inner-box">
                <div class="name-q">
                  <div>
                  {{item.qus}}
                  </div>
                </div>
                <div class="name-t">
                  <div v-for="(title,indexTitle ) in item.title"
                    :key="indexTitle"
                  >
                    {{title}}
                  </div>
                </div>
                <ul class="name-n">
                  <li v-for="(nextTitle,indexNextTitle ) in item.nextTitle"
                    :key="indexNextTitle"
                  >
                    {{nextTitle}}
                  </li>
                </ul>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="main-title">Applicable industries</div>
        <div class="box-card1">
          <div class="box-card-inner"
            v-for="(item,index) in coreList" :key="index">
            <div class="core">
              <div class="title">
                <img :src="item.icon"/>
              </div>
              <div class="content-core">
                {{item.title}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product',
  data () {
    return {
      listArr: [
        {
          title: ['Diversified payment methods', 'Solve the pain points of users'],
          qus: 'Single collection method cannot meet customers demand for diversified payment?',
          nextTitle: [' Build an online-offline integrated payment channel, which supports Alipay, WeChat and Quick Pass. Enable users to enjoy easy, quick and diversified payment methods.',
            'One-stop access to the quick payment.']

        },
        {
          title: ['Compliance account', 'Flexible settlement'],
          qus: 'The financial account is unclear and account checking is tedious?',
          nextTitle: ['The cashier APP Haoshouyin provides for users with quicker, more stable and more comprehensive services, including allocation of upstream and downstream funds, payment of employees salary and bonus, tax treatment, and financial management.']
        },
        {
          title: ['Value-added services', 'Abundant marketing methods'],
          qus: 'Do you have a high demand for cash flow but the financing demand cannot be met?',
          nextTitle: ['Use applet or WeChat store to create private traffic for the store, and develop the stores own capability to expand online customers.',
            'Add payment and bank account at the background, and provide corresponding value-added services according to the customers bank statement of collection.']
        }

      ],
      coreList: [
        {
          icon: require('../assets/a1.png'),
          title: 'Retail'
        },
        {
          icon: require('../assets/a2.png'),
          title: 'Beauty'
        },
        {
          icon: require('../assets/a3.png'),
          title: 'Food Service'
        },
        {
          icon: require('../assets/a4.png'),
          title: 'Apparel'
        },
        {
          icon: require('../assets/a5.png'),
          title: 'Integrated e-commerce'
        },
        {
          icon: require('../assets/a6.png'),
          title: 'Hospitality'
        },
        {
          icon: require('../assets/a7.png'),
          title: 'Education'
        },
        {
          icon: require('../assets/a8.png'),
          title: 'Automobile'
        },
        {
          icon: require('../assets/a9.png'),
          title: 'Logistics'
        },
        {
          icon: require('../assets/a10.png'),
          title: '...'
        }
      ]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.product
  padding-bottom 50px
  .index-image
      height:380px
      background-color: rgba(90, 90, 90, 1);
      background-image: url(../assets/bannerbghsy.jpeg);
      background-repeat: no-repeat;
      background-position: center
     .inner-text
        padding-top 100px
        margin 0 auto
        width 880px
        color #fff
        .title
          font-size 36px
          font-weight 500
        .content
          font-size 14px
          width 500px
          line-height 30px
  .index-next-content
     width 100%
    .inner-content
      width: 1100px
      margin 0 auto
      .main-title
        height:100px
        font-size 24px
        color #4e5969
        font-weight 600
        text-align center
        line-height 100px
      .box-card
          .inner-box
              background #eee
              box-shadow: 0 4px 12px 0 rgb(0 0 0 / 10%);
              padding 50px 10px
              .name-q
                width: 250px
                margin 0 auto
                text-align center
                color #fff
                font-size 18px
                font-weight 600
                padding 10px
                background linear-gradient(89deg, rgba(255,162,162,1) 0%, rgba(255,34,52,1) 100%)
                &>div
                  padding 20px 0
              .name-t
                padding 30px  0 20px 0
                font-size 24px
                line-height 40px
                font-weight 600
                text-align center
              .name-n
                &>li
                  padding-bottom 10px
                  font-weight 600
      .box-card1
        .box-card-inner
          display inline-block
          width 200px
          .core
            text-align center
            padding 20px 0 40px
            .content-core
              padding-top 20px
              font-weight 600
</style>



// WEBPACK FOOTER //
// src/pages/product.vue